import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Autocomplete from "components/DesignComponents/Autocomplete";
import ParamsContext from "context/params/paramsContext";
import { BOOLEAN_FILTER, FALSE, TRUE } from "shared/constants/strings";
import { useMediaQueries } from "shared/hooks/useMediaQueries";
import {
    filterDropdownCustomMargin,
    generalFiltersBlockStyle
} from "shared/styles";
import { DROPDOWN_SIZES, FILTER_NAMES } from "shared/types/enums";

import FilterButton from "../components/FilterButton";
import FilterMenu from "../components/FilterMenu";
import FilterDropdown from "../FilterDropdown";
import { useFilters } from "../hooks";

const DeviceModelFilters = () => {
    const { filterQueryParams, setQueryParams } = useContext(ParamsContext);

    const { t } = useTranslation();
    const { fromLg, toLg } = useMediaQueries();
    const { anchorEl, handleOpenMenu, handleCloseMenu } = useFilters();

    const handleTctWebSupportChange = (value: string | null) =>
        setQueryParams({
            params: {
                [FILTER_NAMES.WebEditorSupport]: value || ""
            },
            resetPage: true,
            filteredValues: {
                filterName: FILTER_NAMES.WebEditorSupport,
                value: value
                    ? [
                          {
                              id: value,
                              name: BOOLEAN_FILTER
                          }
                      ]
                    : []
            }
        });

    const value = filterQueryParams[FILTER_NAMES.WebEditorSupport];

    return (
        <div css={css(generalFiltersBlockStyle)}>
            {fromLg && (
                <FilterDropdown
                    filter={FILTER_NAMES.Platform}
                    placeholder={t(`Filter##${FILTER_NAMES.ModelPlatform}`)}
                    css={css([filterDropdownCustomMargin])}
                />
            )}

            <FilterButton onOpen={handleOpenMenu}>
                {fromLg ? t("Button##more filters") : t("Button##filters")}
            </FilterButton>

            <FilterMenu
                isOpen={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleCloseMenu}
            >
                <div
                    css={css({
                        "& > div + div": {
                            marginTop: "12px"
                        }
                    })}
                >
                    {toLg && (
                        <FilterDropdown
                            filter={FILTER_NAMES.Platform}
                            placeholder={t(
                                `Filter##${FILTER_NAMES.ModelPlatform}`
                            )}
                        />
                    )}

                    <Autocomplete
                        fullWidth
                        size={DROPDOWN_SIZES.Small}
                        textFieldParams={{
                            placeholder: t("Table##tct web support")
                        }}
                        options={[TRUE, FALSE]}
                        value={value || null}
                        getOptionLabel={(option: boolean) =>
                            t(`Table##model task type support##${option}`)
                        }
                        onChange={(_, newValue) =>
                            handleTctWebSupportChange(newValue)
                        }
                    />

                    <FilterDropdown
                        filter={FILTER_NAMES.SupportedTaskType}
                        placeholder={t(
                            `Filter##${FILTER_NAMES.SupportedTaskType}`
                        )}
                    />
                </div>
            </FilterMenu>
        </div>
    );
};

export { DeviceModelFilters };
